// Define report types : constant values are retrieved from the Konek.Enums.Report type in Konek.Utility project
export const reportTypes = {
    FlAG: -1,
    LIST_EMPLOYEES_BY_SENIORITY: 0,
    LIST_EMERGENCY_CONTACTS_BY_EMP_DEPT: 1,
    LIST_EMPLOYEES: 2,
    LIST_EMPLOYEES_FILTERED: 3,
    SENIORITY_BY_EMP: 4,
    EMPLOYEE_DS: 5,
    EMPLOYEE_COMMENT_LIST_BY_SUBCODE_GROUPMENT: 6,
    DETAIL_TS_ENTRIES_BY_SITE_DEPT_PAY_ACTIVITY: 7,
    SUMMARY_TS_ENTRIES_BY_SITE_DEPT_PAY_ACTIVITY: 8,
    SUMMARY_TS_ENTRIES_BY_SITE_DEPT: 9,
    DETAIL_TS_ENTRIES_BY_SITE_DEPT: 10,
    TS_ENTRIES_BY_EMP_DEPT_PAY_PER: 11,
    MISSING_TS_BY_EMP_DEPT_PAY_PER: 12,
    SCHEDULE_TIME_ENTRIES_FROM_TS: 13,
    TS_ENTRIES_BY_PROJ_DEPT_EMP_PAY_PERIOD: 14,
    TS_PUNCH_HOURS_DISPARITY: 15,
    VALIDATION_TS_WITH_PRODUCTION_ORDERS: 16,
    OVERTIME_VALIDATION_TS: 18,
    WEEKLY_TS: 19,
    SUMMARY_WEEKLY_TS: 21,
    SUBCODES_BY_PAY_PROJ_EMP: 22,
    PROJECT_HOURS_ABC: 23,
    TS_ENTRIES_BY_EMP_DEPT_PAY_PER_WITH_APPROVAL: 24,
    GET_HOURS_BY_PROJECT_BETWEEN_2_DATES: 25,
    SCHEDULE_TIME_ENTRIES_FROM_PUNCH: 26,
    SCHEDULE_TIME_ENTRIES_FROM_PUNCH_DEPT: 27,
    DAILY_PUNCH_BY_EMP_DEPT: 28,
    PUNCH_PER_DATE: 29,
    PUNCH_BY_APPROV_PROJ_DATE: 30,
    SCHEDULE_TIME_ENTRIES_FROM_PUNCH_DEPT_BTW_TWO_DATES: 31,
    TS_AND_PUNCH_HOURS_DISPARITY: 32,
    DELAYS_AND_EARLY_DEPARTURES: 33,
    WEEKLY_PUNCH_ENTRIES: 34,
    OVERTIME_VALIDATION: 36,
    FLOOR_PRODUCTIVITY: 37,
    SUMMARY_PUNCH_BY_PROJ_TIMECODE_JOBTITLE: 38,
    PUNCH_DATE_APPROV_ACT: 39,
    PUNCH_DATE_APPROV_ACT_PUNCHED: 40,
    PLANNING_AND_ACTUAL_PUNCH_DISPARITY: 41,
    HOURS_BY_OCCUPATION_WORKED_BY_EMP: 42,
    BILLING_FROM_PAYROLL: 43,
    POINTS_BY_DATE_WITH_ABC_PROJECT: 47,
    HOURS_BY_PROJ: 49,
    DAILY_HTP_PUNCH_DEVIATION_ABC: 51,
    ABC_PROJECT_HOURS_REPORT: 52,
    HOURS_WORKED_BY_PROJECTS: 53,
    NUMBER_OF_DAYS_AWAY_REPORT: 54,
    EMPLOYEE_SCHEDULE_BY_SECTOR: 55,
    SUMMARY_EMPLOYEE_SCHEDULE_BY_DEPT: 56,
    EMPLOYEE_SCHEDULE_BY_APPROV_DEPT: 57,
    EMPLOYEE_SCHEDULE_BY_PROJECT: 58,
    HOURS_BY_DEPT: 59,
    HOURS_BY_DEPT_BY_JOBTITLE: 60,
    EMPLOYEE_SCHEDULE_BY_SHIFT: 61,
    EMPLOYEE_SCHEDULE_WITH_RANGE_DESC: 62,
    EMPLOYEE_SCHEDULE_BY_DEPT_AND_LOCATION: 63,
    EMPLOYEE_SCHEDULE_BY_DEPT: 64,
    NBR_HOURS_PLAN_BY_DEP_WORKSHIFT: 65,
    NBR_HOURS_PLAN_BY_DEP_WORK_SHIFT_ATTENDANCE_LIST: 66,
    NBR_ACTUAL_HOURS_BY_DEP_WORK_SHIFT: 67,
    CALENDAR_ABSENCES: 68,
    OVERTIME: 69,
    TIMESHEET_HOURS_BY_DEPARTMENT_PAY_ACTIVITY_PROJECT: 70,
    TIMESHEET_MONTHLY_HOURS_BY_DEPARTMENT_PAY_ACTIVITY_PROJECT: 71,
    HOURLY_REPORT: 72,
    SCHEDULE_TIME_ENTRIES_FROM_PUNCHTIME: 73,
    ELIGIBLE_BANKBALANCE_FOR_PAYMENT_REQUESTS: 74,
    DETAIL_HOUR_BY_SUBCODES: 75,
    DETAIL_TS_PUNCH_ENTRIES_BY_EMP: 77,
    PUNCH_TS_ENTRIES: 78,
    TIMESHEET: 80,
    TIMESHEET_TASK: 81,
    PERFORMANCE_EVALUATION_EMPLOYEE: 83,
    PERFORMANCE_EVALUATION_SUPERVISOR: 85,
    PERFORMANCE_EVALUATION_COMPARATIVE: 87,
    DAILY_PUNCH_ENTRIES: 89,
    PUNCHED_HOURS_AND_HOURS_ENTERED_DISPARITY: 91,
    WEEKLY_PUNCH_SPREADSHEET: 93,
    LIST_EMPLOYEES_PRESENT: 94,
    PUNCH_PER_DATE_EMPLOYEE: 95,
    ANNEXA: 96,
    PAYROLL_BANK_ACCRUAL: 97,
    NON_BILLABLE_HOURS: 98,
    NON_BILLABLE_TRAINING_HOURS: 99,
    NON_BILLABLE_MILEAGE: 100,
    PUNCH_SCHEDULE_CONFLICTS: 101,
    PLANNED_AND_PUNCHED_HOURS_DIFFERENCE: 102,
    SCHEDULE_BY_PROJECT_GARDIUM: 103,
    PAYROLL_ENTRIES_VALIDATION: 104,
    YEAR_VACANCY: 105,
    DEVISE: 106,
    PERSONAL_CONTACT_REPORT: 107,
    EMERGENCY_CONTACT: 108,
    MONTHLY_PAYROLL_SUMMARY_JOURNAL: 109,
    LIST_INACTIVE_EMPLOYEES_BANKBALANCE: 110,
    LIST_INVALID_SOCIAL_INSURANCE_NUMBERS: 111,
    PAYROLL_CALENDARS: 112,
    KONEK_EMPLOYEE_ACCESS: 113,
    KONEK_EMPLOYEE: 114,
    DESIGNER_HOURS_PER_PROJECT_ACTIVITY: 115,
    TIMESHEET_TASK_DRUIDE: 116,
    PUNCH_TS_ENTRIES_DRUIDE: 117,
    VACATION_ABSENCE_CALENDAR: 118,
    SUMMARY_REPORT_HOURS_BY_ABC_PROJECT_TS: 119,
    SUMMARY_REPORT_HOURS_BY_ABC_PROJECT_PUNCH: 120,
    WEEKLY_PUNCH_BY_PROJ_EMP: 121,
    SUMMARY_PUNCH_DATE_APPROV_ACT: 122,
    HOURS_VALIDATION_CONTRACT_TEMPLATES_BY_PROJ: 123,
    EXTERNAL_TS_AND_ACTUAL_PUNCH_DISPARITY: 124,
    VALID_HOURS_TO_SHIFT_PLAN_MODELS_BY_PROJ_PER: 125,
    EMPLOYEE_SCHEDULE_BY_POS_PER: 126,
    PLANNED_DAILY_PRESENCE_BY_DATE: 127,
    PAYROLL_SUMMARY_JOURNAL_PAYROLL_PROCESSING: 128,
    PAYROLL_SUMMARY_JOURNAL_BY_PROJECT: 129,
    PAYROLL_SUMMARY_JOURNAL_BY_DEPT: 130,
    SALARY_JOURNAL_WITH_EMPLOYERS_SHARES: 133,
    DAILY_REPORT: 158,
    EVENT_REPORT: 159,
};